import { DisplayText } from './displayText';

export class EventsActionFilters {
    field: DisplayText;
    value: string;
}

